import { z } from 'zod';

// リクエスト型定義
export interface VideoLikeReq {
  video_id: string;
}

// レスポンス型定義
export const VideoLikeResSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});
export type VideoLikeRes = z.infer<typeof VideoLikeResSchema>;

export const VideoLikesCountResSchema = z.object({
  likesCount: z.number(),
});
// いいね数のレスポンス型
export interface VideoLikesCountRes {
  likesCount: number;
}

// いいねした人のユーザー情報
export const UserSchema = z.object({
  id: z.string(),
  name: z.string(),
  // nullではなくundefinedを許容するように変更
  icon_path: z.string().optional(),
});
export type User = z.infer<typeof UserSchema>;

export const VideoLikersResSchema = z.object({
  likers: z.array(UserSchema),
});
export type VideoLikersRes = z.infer<typeof VideoLikersResSchema>; 